
const constants = {
    "mode" : "db",
    "emojiTimeOut": 2000,
    "modalTimeOut": 2500,
    "requestTimeOut": 10000,
    "names": ["robbie","seb"]
};

export default constants